<template>
  <div class="pl10 pr10">
    <a-row class="tar mb10" justify="space-between">
      <div>
        <span>类型：</span>
        <a-select
          v-model:value="params.type"
          style="width: 150px;text-align: left;"
          class="mr20 "
          placeholder="请选择"
          allowClear
        >
          <a-select-option :value="1">菜单</a-select-option>
          <a-select-option :value="2">按钮</a-select-option>
        </a-select>

        <span>模块名称：</span>
        <a-input
          allowClear
          style="width: 150px"
          v-model:value="params.moduleName"
          placeholder="请输入"
        ></a-input>
      </div>
      <a-button type="primary" size="small" @click="showModal(true)"
        >新增</a-button
      >
    </a-row>
    <a-table
      rowKey="index"
      size="small"
      bordered
      :columns="columns"
      :data-source="moduleDatas"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.key === 'action'">
          <!-- <a-button type="link" size="small">关联模块</a-button> -->
          <a-button type="link" size="small" @click="showModal(true, record)"
            >编辑</a-button
          >
          <a-button type="link" size="small" @click="deleteModule(record.id)"
            >删除</a-button
          >
        </template>
        <template v-if="column.key === 'type'">
          {{ typeObj[record.type] }}
        </template>
      </template>
    </a-table>
    <!-- 新增与编辑角色 -->
    <a-modal
      v-if="formState.visible"
      :open="formState.visible"
      :title="formState.id ? '更新模块' : '新增模块'"
      @ok="submitmodule"
      @cancel="showModal(false)"
    >
      <a-form
        ref="formRef"
        :model="formState"
        :labelCol="{ span: 8 }"
        :wrapperCol="{ span: 14 }"
        :rules="rules"
      >
        <a-form-item label="类型" name="type">
          <a-select v-model:value="formState.type">
            <a-select-option :value="1">
              菜单
            </a-select-option>
            <a-select-option :value="2">
              按钮
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="模块名称" name="moduleName">
          <a-input
            v-model:value="formState.moduleName"
            placeholder="请输入"
            autocomplete="off"
            all-clear
          />
        </a-form-item>

        <a-form-item
          label="菜单路劲"
          v-if="formState.type === 1"
          name="modulePath"
        >
          <a-input
            v-model:value="formState.modulePath"
            placeholder="请输入"
            autocomplete="off"
            all-clear
          />
        </a-form-item>
        <a-form-item
          label="模块Code"
          v-if="formState.type !== 1"
          name="moduleCode"
        >
          <a-input
            v-model:value="formState.moduleCode"
            placeholder="请输入"
            autocomplete="off"
            all-clear
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>
<script setup>
import { reactive, toRefs, ref, inject, onMounted } from 'vue'

const APIS = inject('APIS')
const {
  getModuleList,
  columns,
  params,
  typeObj,
  moduleDatas
} = APIS.v1_portal_module_list_post_()
const {
  formState,
  rules,
  formRef,
  showModal,
  submitmodule,
  deleteModule
} = APIS.v1_portal_module_add_post_({
  getModuleList
})
onMounted(() => {
  getModuleList()
})
</script>
<style lang="scss" scoped></style>
